module.exports = __webpack_public_path__ + "img/맥형아카데미_6.c99a1e24.jpg";